import React from 'react';

export const Success = ({ className }: { className?: string }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="9" transform="rotate(180 9 9)" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8911 6.12783C15.0467 6.28753 15.0342 6.53479 14.8633 6.68011L6.88975 13.4567C6.73004 13.5924 6.48598 13.5924 6.32627 13.4567L3.13687 10.7461C2.96588 10.6007 2.95341 10.3535 3.10901 10.1938C3.26461 10.0341 3.52936 10.0224 3.70035 10.1678L6.60801 12.639L14.2998 6.10181C14.4708 5.95648 14.7355 5.96813 14.8911 6.12783Z"
      fill="white"
    />
  </svg>
);
